export default function NotFound() {
  return (
    <div className="front">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center mt-5">
          <div className="col-md-7 col-lg-7 col-xs-12 order-md-2 mb-6">
            <img
              src="/assets/img/illustrations/illustration-1.webp"
              alt="..."
              className="img-fluid"
            />
          </div>
          <div className="col-md-5 col-lg-5 col-xs-12 order-md-1">
            <h1 className="display-3 fw-bold text-center">Uh Oh.</h1>
            <p className="mb-5 text-center text-muted">
              How did you reach here? <br />
              But don’t worry, we’ll take care of it for sure. <hr />
              If this persist, contact support : <a href="mailto:support@ideabreed.net">Support</a>
            </p>
            <div className="text-center">
              <a className="btn btn-primary" href="/">
                Back to - CDMIS
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
